import { combineReducers } from 'redux';
import cookieConsent from './cookieConsent';

export default combineReducers({
  cookieConsent,
});



// WEBPACK FOOTER //
// ./src/client/js/store/reducers/cookies/index.js